// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2930":"9a647b6f","3211":"a5586071","5744":"9a647b6f","7662":"a5586071","9246":"a5586071"}[chunkId] + ".chunk.css";
};